@if (isLoading) {
     <nz-skeleton [nzActive]="true"></nz-skeleton>
}
@else {
    @if (technicianStatus.incidentId && technicianStatus.incidentId > 0 && incident) {
        <div class="mobile-incident-container">
            <!-- <h1 class="incident-title"><strong>Active Incident #{{ technicianStatus.incidentNumber }}
                                @if (incident.orderNumber) {
                    / <span style="font-weight: bold;">{{incident.orderNumber}}</span><br />
                }
            </strong></h1> -->
            <div class="incident-header">
                <h1 class="incident-title"><strong>#{{ technicianStatus.incidentNumber }}
                @if (incident.orderNumber) {
                    / <span style="font-weight: bold;">{{incident.orderNumber}}</span><br />
                }
                </strong></h1>
                <button nz-button nzType="default" nzShape="circle" (click)="refreshData()" [nzLoading]="isLoading" class="refresh-btn">
                    <nz-icon nzType="sync" nz-tooltip="Click to Refresh Data"></nz-icon>
                </button>
            </div>
            <div class="incident-details">
                <div class="detail-row">
                    <span class="detail-label"><nz-icon nzType="clock-circle" nzTheme="outline" /> ETA:</span>
                    <span class="detail-value">{{ (incident.breakdownTechnicianDriverEta + 'Z' | date:'HH:mm') || 'N/A' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label"><nz-icon nzType="truck" nzTheme="outline" /></span>
                    <span class="detail-value">{{ incident.clientName }} - {{ incident.fleetVehicle.registrationNumber || 'N/A' }}</span>
                </div>
                <!-- TYRES-->
                @if (incident.tyrePositions && incident.tyrePositions.length > 0) {
                    <div class="detail-row ">
                        <span class="detail-label"><nz-icon nzType="tool" nzTheme="outline" /></span>
                        <span class="detail-value">
                            @for (tyre of incident.tyrePositions; track tyre.tyreLocation) {
                                <div>{{ tyre.size }} - {{ getTyreLocationString(tyre.tyreLocation) }} (Qty: {{ tyre.qty }})</div>
                            }
                        </span>
                    </div>
                }
                <!-- FLEET & VEHICLE -->
                
                <!-- DESCRIPTION -->
                @if (incident.incidentDescription) {
                    <div class="detail-row">
                        <span class="detail-label"><nz-icon nzType="info-circle" nzTheme="outline" /></span>
                        <span class="detail-value">
                            {{ showFullDescription ? incident.incidentDescription : getTruncatedDescription() }}
                            @if (incident.incidentDescription.length > DESCRIPTION_MAX_LENGTH) {
                                <button nz-button nzType="link" nzSize="small" (click)="toggleDescription()" style="padding: 0; height: auto;">
                                    {{ showFullDescription ? 'Show Less' : 'Read More' }}
                                </button>
                            }
                        </span>
                    </div>
                }
                
                <!-- DRIVER -->
                <div class="collapsible-section">
                    <div class="section-toggle detail-row" (click)="toggleDriverDetails()">
                        <span>
                            <nz-icon nzType="user" nzTheme="outline" /> 
                            Driver:
                        </span>
                        <nz-icon [nzType]="showDriverDetails ? 'up' : 'down'" nzTheme="outline" />
                    </div>
                    @if (showDriverDetails) {
                        <div class="section-content">
                            <div><strong>Name:</strong> {{ incident.driver.name || 'N/A' }}</div>
                            @if (incident.driver.phoneNumber) {
                                <div class="phone-row">
                                    <span><strong>Phone:</strong> {{ incident.driver.phoneNumber }}</span>
                                    <a [href]="getWhatsAppLink()" target="_blank" rel="noopener noreferrer">
                                        <button nz-button nzSize="large" nzShape="circle" class="whatsapp-btn">
                                            <nz-icon nzType="whats-app" nzTheme="outline" />
                                        </button>
                                    </a>
                                </div>
                            }
                        </div>
                    }
                </div>
                <!-- OPERATOR -->
                @if (getServiceProviderOperator()) {
                    <div class="collapsible-section">
                        <div class="section-toggle detail-row" (click)="toggleOperatorDetails()">
                            <span>
                                <nz-icon nzType="phone" nzTheme="outline" />
                                Operator:
                            </span>
                            <nz-icon [nzType]="showOperatorDetails ? 'up' : 'down'" nzTheme="outline" />
                        </div>
                        @if (showOperatorDetails) {
                            <div class="section-content">
                                <div><strong>Name:</strong> {{ getServiceProviderOperator()!.name || 'N/A' }}</div>
                                @if (getServiceProviderOperator()!.cellNumber) {
                                    <div class="phone-row">
                                        <span><strong>Phone:</strong> {{ getServiceProviderOperator()!.cellNumber }}</span>
                                        <a [href]="getOperatorWhatsAppLink()" target="_blank" rel="noopener noreferrer">
                                            <button nz-button nzSize="large" nzShape="circle" class="whatsapp-btn">
                                                <nz-icon nzType="whats-app" nzTheme="outline" />
                                            </button>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }                   
            </div>
            <div class="action-buttons">
                
                <!-- @if (hasExistingImages()) { -->
                    <button nz-button nzType="default" nzSize="large" nzBlock (click)="onViewImages()">
                        <nz-icon nzType="file-image" nzTheme="outline" />
                        Add/View Images ({{ getImageCount() }})
                    </button>
                @if (hasPendingImages()) {
                <nz-alert nzType="warning" [nzMessage]="pendingImages.length + ' image(s) pending upload. They will sync automatically when online.'" nzShowIcon style="margin-bottom: 16px; cursor: pointer;"></nz-alert>
                }
                @if (hasExistingImages()) {
                    <button nz-button nzType="primary" nzSize="large" nzBlock [disabled]="hasPendingImages()" (click)="onCompleteIncident()" style="background-color: #52c41a; border-color: #52c41a;">
                        <nz-icon nzType="check-circle" nzTheme="outline" />
                        Complete Breakdown
                    </button>
                }
                <!-- } -->
                <!-- <div class="photo-buttons">
                    <button nz-button nzType="default" nzSize="large" (click)="galleryInput.click()">
                        <nz-icon nzType="picture" nzTheme="outline" />
                        Select Images
                    </button>
                    <button nz-button nzType="default" nzSize="large" (click)="cameraInput.click()">
                        <nz-icon nzType="camera" nzTheme="outline" />
                        Take Photo
                    </button>
                    <input #galleryInput type="file" accept="image/*" multiple (change)="onGallerySelect($event)" style="display: none;" />
                    <input #cameraInput type="file" accept="image/*" capture="environment" (change)="onCameraCapture($event)" style="display: none;" />
                </div> -->
                <!-- @if (hasExistingImages()) {
                    <button nz-button nzType="primary" nzSize="large" nzBlock [disabled]="hasPendingImages()" (click)="onCompleteIncident()" style="background-color: #52c41a; border-color: #52c41a;">
                        <nz-icon nzType="check-circle" nzTheme="outline" />
                        Complete Incident
                    </button>
                } -->
            </div>


            <div class="map-container">
                <iframe 
                    [src]="mapUrl"
                    width="100%" 
                    height="100" 
                    style="border:0;" 
                    allowfullscreen="" 
                    loading="lazy">
                </iframe>
            </div>
            <div class="location-update-section">
                <button nz-button nzType="default" nzSize="large" nzBlock (click)="onSendLocationUpdate()" [nzLoading]="isSendingLocationUpdate">
                    <nz-icon nzType="environment" nzTheme="outline" />
                    @if (!incident.breakdownTechnicianDriverEta) {
                        I am Leaving - Send Location
                    } @else {
                    Send Location Update
                    }
                </button>
                <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onClickOpenGoogleMaps()">
                    <nz-icon nzType="export" nzTheme="outline" />
                    Navigate on Google Maps
                </button>
            </div>


        </div>
    } @else {
        <div class="status-header">
            <h1 class="current-status" [ngClass]="{
                'status-available': technicianStatus.statusId === 1,
                'status-unavailable': technicianStatus.statusId === 2
            }">
                Current Status: <span class="status-text">{{ getDriverStatus() }}</span>
            </h1>
            @if(technicianStatus.dtLogged) {
                <p class="last-updated">
                    <nz-icon nzType="clock-circle" nzTheme="outline"></nz-icon>
                    Last updated: {{ technicianStatus.dtLogged + 'Z' | date:'HH:mm' }}
                </p>
            }
        </div>
        
        <!-- AVAILABLE BLOCK -->
        <div class="status-block available" [class.active]="technicianStatus.statusId === 1">
            <button class="status-main-button available" (click)="onChangeStatus(1, 0)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
                <h1>AVAILABLE</h1>
            </button>
            <!-- <div class="status-time-buttons">
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(1, 15)">
                    <strong>15 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(1, 30)">
                    <strong>30 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(1, 60)">
                    <strong>1 hour</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(1, 120)">
                    <strong>2 hours</strong>
                </button>
            </div> -->
        </div>
        <!-- UNAVAILABLE BLOCK -->
        <div class="status-block unavailable" [class.active]="technicianStatus.statusId === 2">
            <button class="status-main-button unavailable" (click)="onChangeStatus(2, 0)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m388-212-56-56 92-92-92-92 56-56 92 92 92-92 56 56-92 92 92 92-56 56-92-92-92 92ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
                <h1>UNAVAILABLE</h1>
            </button>
            <!-- <div class="status-time-buttons">
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 15)">
                    <strong>15 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 30)">
                    <strong>30 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 60)">
                    <strong>1 hour</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 120)">
                    <strong>2 hours</strong>
                </button>
            </div> -->
        </div>
        <!-- BUSY BLOCK -->
        <div class="status-block busy" [class.active]="technicianStatus.statusId === 3">
            <button class="status-main-button busy" (click)="onChangeStatus(3, 0)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m388-212-56-56 92-92-92-92 56-56 92 92 92-92 56 56-92 92 92 92-56 56-92-92-92 92ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg>
                <h1>BUSY</h1>
            </button>
            <!-- <div class="status-time-buttons">
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 15)">
                    <strong>15 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 30)">
                    <strong>30 min</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 60)">
                    <strong>1 hour</strong>
                </button>
                <button nz-button nzType="default" nzSize="large" (click)="onChangeStatus(2, 120)">
                    <strong>2 hours</strong>
                </button>
            </div> -->
        </div>
    
    }
}
<nz-modal 
    [(nzVisible)]="isViewImagesModalVisible" 
    nzTitle="Breakdown Images" 
    (nzOnCancel)="isViewImagesModalVisible = false" 
    nzOkText="Close"
    (nzOnOk)="isViewImagesModalVisible = false"
    nzWidth="90%"
    [nzFooter]="null">
    <ng-container *nzModalContent>
        <nz-collapse >
        @for (cat of imageCategories; track cat.categoryId) {
            <nz-collapse-panel [nzHeader]="nzCollapsePanelHeader" > 
                <ng-template #nzCollapsePanelHeader>
                    {{ cat.categoryName }} ({{ getCategoryImages(cat.categoryId).length }})
                    @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
                        <nz-tag nzColor="orange" style="margin-left: 8px;">
                            {{ getPendingImagesByCategory(cat.categoryId).length }} Pending
                        </nz-tag>
                    }
                </ng-template>

                    <div class="modal-photo-buttons">
                        <button nz-button nzType="default" nzSize="large" (click)="galleryInput.click()">
                            <nz-icon nzType="picture" nzTheme="outline" />
                            Select Images
                        </button>
                        <button nz-button nzType="default" nzSize="large" (click)="cameraInput.click()">
                            <nz-icon nzType="camera" nzTheme="outline" />
                            Take Photo
                        </button>
                        <input #galleryInput type="file" accept="image/*" multiple (change)="onGallerySelect($event, cat)" style="display: none;" />
                        <input #cameraInput type="file" accept="image/*" capture="environment" (change)="onCameraCapture($event, cat)" style="display: none;" />
                    </div> 
                    @for (doc of getCategoryImages(cat.categoryId); track doc.documentId) {
                        <div class="modal-image-card">
                            <img [src]="doc.localBase64 || doc.url" [alt]="doc.description" />
                            <div style="padding: 8px; background-color: #f5f5f5;">
                                <div class="image-card-footer">{{ doc.description }}</div>
                            </div>
                        </div>
                    }
                @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
                <h4 class="pending-images-header">Pending Upload ({{ getPendingImagesByCategory(cat.categoryId).length }})</h4>
                @for (img of getPendingImagesByCategory(cat.categoryId); track img.id) {
                    <div class="modal-image-card pending-image-card">
                        <img [src]="img.fileBase64" [alt]="img.name" />
                        <div class="image-card-footer">
                            <span style="font-size: 12px; color: #666;">{{ img.name }}</span>
                            <nz-tag [nzColor]="img.status === 'failed' ? 'red' : 'orange'">
                                {{ img.status === 'failed' ? 'Failed' : 'Pending' }}
                            </nz-tag>
                        </div>
                    </div>
                }
            }
            </nz-collapse-panel>  
        }
        </nz-collapse>
         
        <div style="display: flex; flex-direction: column; gap: 16px;">
            <!-- @for (doc of getIncidentImages(); track doc.documentId) {
                <div style="border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden;">
                    <img [src]="doc.url" [alt]="doc.description" style="width: 100%; height: auto; display: block;" />
                    <div style="padding: 8px; background-color: #f5f5f5;">
                        <div style="font-size: 12px; color: #666;">{{ doc.description }}</div>
                    </div>
                </div>
            } -->
            <!-- @if (pendingImages.length > 0) {
                <h4 style="margin-top: 16px;">Pending Upload ({{ pendingImages.length }})</h4>
                @for (img of pendingImages; track img.id) {
                    <div style="border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden; margin-bottom: 8px;">
                        <img [src]="img.fileBase64" [alt]="img.name" style="width: 100%; height: auto; display: block;" />
                        <div style="padding: 8px; background-color: #fff7e6; display: flex; justify-content: space-between; align-items: center;">
                            <span style="font-size: 12px; color: #666;">{{ img.name }}</span>
                            <nz-tag [nzColor]="img.status === 'failed' ? 'red' : 'orange'">
                                {{ img.status === 'failed' ? 'Failed' : 'Pending' }}
                            </nz-tag>
                        </div>
                    </div>
                }
            } -->
        </div>
    </ng-container>
</nz-modal>

<nz-modal 
    [(nzVisible)]="isCompleteIncidentModalVisible" 
    nzTitle="Complete Breakdown" 
    (nzOnCancel)="isCompleteIncidentModalVisible = false"
    [nzOkLoading]="isCompletingIncident"
    nzWidth="90%"
    [nzFooter]="modalFooter">
    <ng-container *nzModalContent>
        <div style="padding: 16px 0; text-align: center;">
            <nz-icon nzType="warning" nzTheme="outline" style="color: #fa8c16; font-size: 48px; margin-bottom: 16px;"></nz-icon>
            <p style="font-size: 16px; margin-bottom: 8px;"><strong>Are you sure you want to complete this breakdown?</strong></p>
            <p style="color: #666;">This action cannot be undone. Please ensure all work has been completed and documented.</p>
        </div>
    </ng-container>
    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="isCompleteIncidentModalVisible = false">
            <nz-icon nzType="close" nzTheme="outline" />
            Cancel
        </button>
        <button nz-button nzType="primary" [nzLoading]="isCompletingIncident" (click)="onConfirmCompleteIncident()" style="background-color: #52c41a; border-color: #52c41a;">
            <nz-icon nzType="check-circle" nzTheme="outline" />
            Complete Breakdown
        </button>
    </ng-template>
</nz-modal>